let orders = require('../../actions/account/orders');
let utils = require('../../actions/utils');
let currentOrderGroups = require('../groups/account/current-order');
let accountGroups = require('../groups/account');
let user = require('../../actions/user');

module.exports = {
    onCreateUserStub: [
        [
            orders.createUserStub,
            {
                success: [
                    utils.set(['account', 'orders', 'createUser', 'notFound'], false),
                    utils.setFromArgsToState('user', ['account', 'orders', 'currentOrder', 'localChanges', 'selectedUser']),
                    ...accountGroups.getUsersList,
                    [
                        user.isManager,
                        {
                            true: [
                                utils.set(['account', 'orders', 'currentOrder', 'tooltips', 'showUserMustBeSelected'], false),
                            ],
                            false: [
                                ...currentOrderGroups.setUserGroup
                            ]
                        }
                    ]
                ],
                error: [
                    utils.set(['account', 'orders', 'createUser', 'error', 'createError'], true)
                ]
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/account/create-user.js